<script>
  import relatorioTecnicoProjetoServico from '../servico';
  import PlanoTrabalhoEquipe from './compartilhado/FormPlanoTrabalhoEquipe.vue';

  export default {
    components: { PlanoTrabalhoEquipe },
    data() {
      return {
        planoTrabalhoEquipe: [],
        carregando: true,
        configuracao: this.$storage.configuracao(),
      }
    },
    mounted() {
      this.$root.tituloDaPagina = 'Plano de Trabalho Equipe';
      this.$root.botaoAcaoMostrar = false;
    },
    methods: {
      carregar(id) {
        this.carregando = true;

        let planoTrabalhoEquipe = null;

        relatorioTecnicoProjetoServico
          .obterPlanoTrabalhoEquipe(id)
          .then(dados => {
            planoTrabalhoEquipe = dados;
          })
          .then(() => {
            this.$set(this, 'planoTrabalhoEquipe', planoTrabalhoEquipe);
            this.carregando = false;
          });
      },
      resetarComponente() {
        Object.assign(this.$data, this.$options.data.apply(this));
      },
    },
    created() {
      if (this.$route.params.id) {
        this.carregar(this.$route.params.id);
      }
    },
    watch: {
    }
  }
</script>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">

      <div class="row">
        <div class="col-xs-12">
          <div class="ibox float-e-margins" v-if="carregando">
            <div class="ibox-content">
              <p class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>
            </div>
          </div>

          <div class="tabs-container" v-show="!carregando" id="tabs">
            <ul class="nav nav-tabs">
              <li class="active">
                <a data-toggle="tab"
                   href="#tab-plano-trabalho-equipe">
                  Plano Trabalho Equipe
                </a>
              </li>
            </ul>
            <div class="tab-content">

              <div id="tab-plano-trabalho-equipe" class="tab-pane active">
                <div class="panel-body">
                  <plano-trabalho-equipe ref="planoTrabalhoEquipe"
                                    :planotrabalhoequipe="planoTrabalhoEquipe">
                  </plano-trabalho-equipe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
     
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">    
            <router-link class="btn btn-default"
                         :to="{ name: 'relatorio-tecnico-projeto' }"
                         active-class="">
              <i class="fa fa-arrow-left"></i>
              Voltar
            </router-link>
          </div>
        </div>
      </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio-tecnico-projeto/componentes/RelatorioTecnicoProjetoEquipe.vue